import { Benefits } from "@/lib/interfaces/embed";
import { Card } from "../../../ui/components/ui/card";
import { getIcon } from "../icon-map";
import { withAlpha } from "./v2-helpers";

export function JobPostsV2Benefits({ brandColor, benefits }: { brandColor: string; benefits?: Benefits }) {
  if (!benefits) return null;

  const iconBg = withAlpha(brandColor, 0.2);

  return (
    <>
      <div className="text-center max-w-2xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold tracking-tight text-gray-900">{benefits.title}</h2>
        <p className="mt-3 text-sm md:text-base text-gray-600">{benefits.description}</p>
      </div>

      <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {(benefits.benefitItems || []).map((item, idx) => {
          const Icon = item.iconKey ? getIcon(item.iconKey) : null;
          return (
            <Card key={`${item.title}-${idx}`} className="p-6 shadow-sm transition-shadow hover:shadow-md">
              <div className="flex flex-col gap-3">
                <div
                  className="h-10 w-10 rounded-full flex items-center justify-center"
                  style={{ backgroundColor: iconBg }}
                  aria-hidden="true"
                >
                  {Icon ? (
                    <span className="[&>svg]:w-5 [&>svg]:h-5" style={{ color: brandColor }}>
                      <Icon />
                    </span>
                  ) : null}
                </div>
                <div className="text-sm font-semibold text-gray-900">{item.title}</div>
                <div className="text-sm text-gray-600 leading-relaxed">{item.description}</div>
              </div>
            </Card>
          );
        })}
      </div>
    </>
  );
}
